<template>
    <div v-if="showCommentDialog">
        <v-overlay>
            <div class="overlay_content ">
                <div class="content">
                    <div class="mt-2">
                        <v-container>
                            <v-row>
                                <v-col cols="1" class="avatar">
                                    <img :src="image" class="user_img" />
                                </v-col>
                                <v-col cols="7">
                                    <div class="name">
                                        <v-row>
                                            <label
                                                class="--font"
                                                style="font-weight: 500"
                                            >
                                                Vinayak Desai
                                                <!-- <h1>HELLO</h1> -->
                                            </label>
                                        </v-row>
                                        <v-row>
                                            <small
                                                class="secondary-font lowerText"
                                            >
                                                12 May 2022 at 16:20
                                                <!-- <time-ago
                                  :datetime="postDetails.time"
                                  long
                                ></time-ago> -->
                                            </small>
                                        </v-row>
                                    </div>
                                </v-col>
                                <v-spacer />
                                <v-col>
                                    <div class="flex">
                                        <div v-for="i in 5" :key="i">
                                            <v-icon size="16" color="#30A46C">
                                                mdi-star</v-icon
                                            >
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                            <div>
                                <p class="--font comment_desc">
                                    Life changing agri app for farmers. One of
                                    the best app for farmers. One stop solutions
                                    for farmers. Farmers can get daily update on
                                    weather, buy cattles as per their choice,
                                    sale crops, start farm buisness, connect
                                    with local area farmers and get suggestions.
                                    Great app.
                                </p>
                            </div>
                        </v-container>
                    </div>
                     <div>
                        <v-container>
                            <v-row>
                                <v-col cols="1" class="avatar">
                                    <img :src="image" class="user_img" />
                                </v-col>
                                <v-col cols="7">
                                    <div class="name">
                                        <v-row>
                                            <label
                                                class="--font"
                                                style="font-weight: 500;color:#338937"
                                            >
                                              You replied
                                                <!-- <h1>HELLO</h1> -->
                                            </label>
                                        </v-row>
                                        <v-row>
                                            <small
                                                class="secondary-font lowerText"
                                            >
                                                12 May 2022 at 16:20
                                                <!-- <time-ago
                                  :datetime="postDetails.time"
                                  long
                                ></time-ago> -->
                                            </small>
                                        </v-row>
                                    </div>
                                </v-col>
                                <v-spacer />
                                <!-- <v-col>
                                    <div class="flex">
                                        <div v-for="i in 5" :key="i">
                                            <v-icon color="#30A46C">
                                                mdi-star</v-icon
                                            >
                                        </div>
                                    </div>
                                </v-col> -->
                            </v-row>
                            <div>
                                <p class="--font comment_desc">
                                    Life changing agri app for farmers. One of
                                    the best app for farmers. One stop solutions
                                    for farmers. Farmers can get daily update on
                                    weather, buy cattles as per their choice,
                                    sale crops, start farm buisness, connect
                                    with local area farmers and get suggestions.
                                    Great app.
                                </p>
                            </div>
                        </v-container>
                    </div>
                    <div>
                        <button class="edit_reply_button"> Edit Reply</button>
                    </div>
                </div>
                <div>
                    <button class="close_button" @click="showCommentDialog=!showCommentDialog">Close</button>
                </div>
            </div>
        </v-overlay>
    </div>
</template>

<script>
export default {
    name: "editComment",
    data() {
        return {
            showCommentDialog: false,
            image: require("../../../../../temp/assets/1.svg"),
        };
    },
};
</script>

<style scoped>
.overlay_content {
    margin: auto;
    padding: auto;
    position: relative;
    top: 25%; /* 25% from the top */
    width: 100%; /* 100% width */
    text-align: center; /* Centered text/links */
}
.content {
    background-color: white;
    max-width: 500px;
    padding: 1rem;
}
.user_img {
    height: 40px;
    transform: translateY(-10px);
}
.name {
    margin-left: 1rem;
}
.comment_desc {
    text-align: left;
    font-size: 16px;
}
.close_button{
background-color: white;
color: #000;
padding: 1rem;
margin-top: 1rem;
width: 200px !important;border-radius: 30px;
}
.edit_reply_button{
    background-color: #318535;
    width: 100% !important;
    padding: .4rem;
    border-radius: 3px;
    margin-bottom: .4rem;
}
</style>